import { Injectable } from '@angular/core';
import { ListView, ListViewProviderDirective } from '@ntap/core';
import { filter, map } from 'rxjs';

@Injectable()
export class ParentListViewProvider extends ListViewProviderDirective<ListView> {
  get selectedParentItem$() {
    return this.selectedItems$.pipe(
      filter((selected) => !!selected && selected.length > 0),
      map((selected) => selected[0])
    );
  }
}
